var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrench(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9135 1.18205C16.9036 0.584994 18.3716 3.04269 16.9024 4.51191L15.1213 6.29303C14.7307 6.68355 14.7307 7.31672 15.1213 7.70724L16.2928 8.87882C16.6834 9.26934 17.3165 9.26934 17.7071 8.87882L19.4882 7.0977C20.9574 5.62848 23.4151 7.09643 22.818 9.08661L21.3251 14.063C20.9891 15.1829 20.0333 16.0055 18.8759 16.1708L13.4713 16.9429L8.12126 22.293C6.94969 23.4646 5.05019 23.4646 3.87862 22.293L1.70705 20.1214C0.535474 18.9499 0.535478 17.0504 1.70705 15.8788L7.05713 10.5287L7.82921 5.1242C7.99455 3.96682 8.8172 3.01093 9.93701 2.67498L14.9135 1.18205ZM15.4882 3.0977L10.5117 4.59064C10.1384 4.70262 9.86422 5.02125 9.80911 5.40704L8.94275 11.4715L3.12126 17.293C2.73074 17.6835 2.73074 18.3167 3.12126 18.7072L5.29284 20.8788C5.68336 21.2693 6.31653 21.2693 6.70705 20.8788L12.5285 15.0573L18.593 14.1909C18.9788 14.1358 19.2975 13.8616 19.4094 13.4883L20.9024 8.51191L19.1213 10.293C17.9497 11.4646 16.0502 11.4646 14.8786 10.293L13.7071 9.12146C12.5355 7.94988 12.5355 6.05039 13.7071 4.87881L15.4882 3.0977Z",
    fill: "#5C6278"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.bf4c56e520d3cdca68e9c30f8aef3738.svg";
export { ForwardRef as ReactComponent };